module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-form-v2"
  }, [(_vm.$data.contentUuid) ? _c('form', {
    on: {
      "submit": _vm.postComment
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentInput),
      expression: "commentInput"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Add a comment"
    },
    domProps: {
      "value": (_vm.commentInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-submit",
    attrs: {
      "type": "submit",
      "value": "Post",
      "disabled": !_vm.commentInput || _vm.disabled
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.$data.contentUuid) ? _c('div', {
    staticClass: "archived"
  }, [_vm._v("Comments for this post have been archived")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5e33bb2!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/molecules/comment-form/comment-form.vue
// module id = 704
// module chunks = 4